/**
 *  Available column types
 * 'selected' - Used to determine if a row is selected, i.e. the checkbox column
 * 'toggle_columns' - Used as a column to show the toggle columns menu
 */
export type RDS_DATA_DICTIONARY_COLUMNS =
  | 'dataType'
  | 'decimals'
  | 'endPosition'
  | 'fixedStorageWidth'
  | 'hasClassification'
  | 'label'
  | 'name'
  | 'description'
  | 'questionText'
  | 'selected'
  | 'startPosition'
  | 'isMeasure'
  | 'isRequired'
  | 'isWeight';

/**
 * Describes a column in a RDS Data Dictionary Table
 */
export class RdsDataDictionaryTableColumn {
  /**
   * Creates an instance of RdsDataDictionaryTableColumn.
   * @param property variable property name
   * @param label display text for property
   * @param index order the column will appear in the table
   * @param required whether the property is required and can't be toggled, defaults to false
   */
  constructor(public property: RDS_DATA_DICTIONARY_COLUMNS, public label: string, public index: number, public required = false) {}
}

export const RDS_DATA_DICTIONARY_ALL_COLUMNS: ReadonlyArray<RdsDataDictionaryTableColumn> = Object.freeze([
  new RdsDataDictionaryTableColumn('selected', 'Selected', 0, true),
  new RdsDataDictionaryTableColumn('name', 'Name', 1),
  new RdsDataDictionaryTableColumn('label', 'Label', 2),
  new RdsDataDictionaryTableColumn('dataType', 'Data Type', 3),
  new RdsDataDictionaryTableColumn('hasClassification', 'Has Classification', 4),
  new RdsDataDictionaryTableColumn('description', 'Description', 5),
  new RdsDataDictionaryTableColumn('questionText', 'Question Text', 6),
  new RdsDataDictionaryTableColumn('isMeasure', 'Is Measure', 7),
  new RdsDataDictionaryTableColumn('isRequired', 'Required', 8),
  new RdsDataDictionaryTableColumn('isWeight', 'Is Weight', 9),
]);
